import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import focalPointApiClient from 'Services/Apis/FocalPoint/conciergeApiClient';

export const sendEmailThunk = createAsyncThunk(
    `SendEmailSlicer/sendEmailThunk`,
    async ({ participant }, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
        };

        var object = {
            id: participant.id,
            creditRequestId: participant.creditRequestId,
            email: participant.email,
            login: participant.document,
            name: participant.participantName,
            registered: participant.registered,
            value: participant.quantityPoints
        }

        const { data } = await focalPointApiClient.post(
            `/Email/Transaction`,
            object,
            {
                headers,
            });
        return data;
    }
);

const initialState = {
    dataSendEmail: false,
    loadingSendEmail: false,
    errorSendEmail: false,
};

const SendEmailSlicer = createSlice({
    name: 'SendEmail',
    initialState,
    reducers: {
        resetDataSendEmail: (state) => {
            state.dataSendEmail = false;
            state.loadingSendEmail = false;
            state.errorSendEmail = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(sendEmailThunk.pending, (state) => {
            state.dataSendEmail = false;
            state.loadingSendEmail = true;
            state.errorSendEmail = false;
        });
        builder.addCase(sendEmailThunk.fulfilled, (state, action) => {
            state.dataSendEmail = true;
            state.loadingSendEmail = false;
            state.errorSendEmail = false;
        });
        builder.addCase(sendEmailThunk.rejected, (state) => {
            state.dataSendEmail = false;
            state.loadingSendEmail = false;
            state.errorSendEmail = true;
        });
    },
});

export const { resetDataSendEmail } = SendEmailSlicer.actions;
export default SendEmailSlicer.reducer;